export default __webpack_public_path__ + "static/media/arrow_left.ff312fcb.svg";